<template>
    <div class="container-fluid">
        <div class="titlle_div">
            <h5 class="title">Reasignar PQR</h5>
        </div>        
        <emt-form ref="reassignment-form" v-bind:itemsFormActivityReassignment="itemsFormActivityReassignment" v-bind:resource="itemResource" v-bind:typeactivity="typeactivity" v-on:change="changelist"></emt-form>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import router from '@/router'
import { Arrays } from '@/helpers'
import generic from '@/generic'
import Config from '@/config'
import EmtForm from '@/components/emt-form-pqr'

export default{
    name: 'emt-reassignment',
    data: function () {
        return {
            itemsFormActivityReassignment: [
                {
                    'name': 'note',
                    'label': 'Nota',
                    'placeholder': 'Ingrese nota para la redirección',
                    'value': null,
                    'maxlength': '5000',
                    'type': 'textarea',
                    'rows': '10',
                    'cols': '10',
                    'errors': []
                }, {
                    'name': 'unit',
                    'label': 'Unidad',
                    'placeholder': 'Seleccione una unidad',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': [],
                    'dependencies': ['area']
                }, {
                    'name': 'area',
                    'label': 'Área',
                    'placeholder': 'Seleccione área',
                    'value': null,
                    'type': 'select',
                    'select_options': [],
                    'errors': [],
                    'dependencies': []
                }
            ],
            itemResource: [
                {
                    'resourcePqr': '/pqr/',
                    'resourceAttachment': '/attachment/',
                    'resourceActivity': '/activity/'
                }
            ],
            typeactivity: 'reassignment'
        }
    },
    created: function () {
        if (!Cookies.get('token')) {
            router.push('/login')
            return
        }
        generic.setToken()
        this.getUnit()
        // this.getArea()
        // this.getResponsible()
    },
    methods: {
        /*
        *esta funcion permite consultar y listar los tipos de pqr
        */
        changelist: function (item) {
            var itemSelected = Arrays.getItemBy(item.select_options, 'value', item.value)
            itemSelected = itemSelected === null || itemSelected === undefined ? {id: '', value: ''} : itemSelected
            var callbackObject = {}
            switch (item.name) {
            case 'unit':
                var id = typeof itemSelected !== undefined ? itemSelected.id : ''
                callbackObject = {
                    functions: [this.getArea],
                    arguments: [id]
                }
                Arrays.clearSelect(this.itemsFormActivityReassignment, item, callbackObject)
                break
            }
        },
        getUnit: function (value) {
            var self = this
            self.$http.get(Config.api + '/unit/?nopaginate=1&is_active=true&ordering=name').then(function (response) {
                for (var data in response.body) {
                    self.itemsFormActivityReassignment[1].value = ''
                    self.itemsFormActivityReassignment[1].select_options.push({
                        value: response.body[data].url,
                        text: response.body[data].name,
                        id: response.body[data].id
                    })
                }
            }, function (response) {
                console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
            })
        },
        getArea: function (value) {
            try {
                var self = this
                if (self.itemsFormActivityReassignment[1].value !== undefined && self.itemsFormActivityReassignment[1].value !== null && value !== null && value !== undefined && value !== '') {
                    var id = value
                    self.$http.get(Config.api + '/area/?nopaginate=1&is_active=true&ordering=name&unit=' + id).then(function (response) {
                        for (var data in response.body) {
                            self.itemsFormActivityReassignment[2].select_options.push({
                                value: response.body[data].url,
                                text: response.body[data].name,
                                id: response.body[data].id,
                                responsible: response.body[data].responsible
                            })
                        }
                    }, function (response) {
                        console.log('SE HA PRESENTADO UN ERROR CARGANDO EL SERVICIO')
                    })
                }
            } catch (e) {
                self.itemsFormActivityReassignment[2].select_options.push({
                    value: '',
                    text: '',
                    id: '',
                    responsible: ''
                })
            }
        }
    },
    components: {
        'emt-form': EmtForm
    }
}
</script>



// WEBPACK FOOTER //
// emt-reassignment.vue?e688cf06